<template>
    <div class="VehicleCreateModal">
        <h1>Add {{ vehicleType ? vehicleType : 'vehicle' }}</h1>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <div class="main">
            <VehicleForm
                ref="vehicleForm"
                v-bind.sync="vehicle"
                :forcedVehicleType="vehicleType"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Save</Button>
        </div>
    </div>
</template>

<script>
import VehicleForm from '@/views/company/vehicle/components/VehicleForm';
import vehicleCreateMixin from '@/mixins/vehicleCreateMixin';

export default {
    name: 'VehicleCreateModal',

    mixins: [vehicleCreateMixin],

    components: { VehicleForm },

    props: {
        onVehicleCreated: { type: Function, required: true },
        vehicleType: { type: String },
    },

    mounted() {
        if (this.vehicleType) {
            this.vehicle.type = this.vehicleType;
        }

        this.$analytics.trackModalView(this.$options.name, {
            vehicle_type: this.vehicleType,
        });
    },

    methods: {
        async handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'save', {
                model_type: 'vehicle',
                model_action: 'create',
                vehicle_type: this.vehicleType,
            });

            const newVehicle = await this.createVehicle();
            if (newVehicle) {
                this.onVehicleCreated(newVehicle);
                this.$emit('close');
            }
        },

        handleCancel() {
            this.$analytics.trackButtonClick(this.$options.name, 'cancel', {
                model_type: 'vehicle',
                model_action: 'create_cancel',
                vehicle_type: this.vehicleType,
            });

            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.VehicleCreateModal {
    @extend %modal;

    .main {
        max-height: 60vh;
        overflow-y: auto;
        margin: 1rem 0;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: center;
    }
}
</style>
